import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const ValuePropositions = () => {
  const values = [
    {
      icon: 'Shield',
      title: '100% Authentic',
      description: 'Only genuine products from authorized brands',
      color: 'text-blue-600',
      bgColor: 'bg-blue-500/10'
    },
    {
      icon: 'Truck',
      title: 'Free Shipping',
      description: 'Complimentary delivery on orders over $50',
      color: 'text-green-600',
      bgColor: 'bg-green-500/10'
    },
    {
      icon: 'Award',
      title: 'Expert Curated',
      description: 'Hand-picked by beauty professionals',
      color: 'text-purple-600',
      bgColor: 'bg-purple-500/10'
    },
    {
      icon: 'RotateCcw',
      title: 'Easy Returns',
      description: '30-day hassle-free return policy',
      color: 'text-orange-600',
      bgColor: 'bg-orange-500/10'
    }
  ];

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-background to-muted/30">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {values?.map((value, index) => (
            <motion.div
              key={value?.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="text-center"
            >
              <div className={`${value?.bgColor} ${value?.color} w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4`}>
                <Icon name={value?.icon} size={32} />
              </div>
              <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
                {value?.title}
              </h3>
              <p className="text-muted-foreground">
                {value?.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePropositions;